import React, { useEffect, useState } from 'react';
import { Grid } from "@material-ui/core";
import "./CustomerInfoSidebar.scss";
import { useSelector } from 'react-redux';
import { TABLET_VIEW_TRANSLATION } from '../../../constants/translations/customer/tablet/tabletView';
import moment from 'moment';
import { getCustomerOrders } from '../../../functions/api/customer-page';
import { generalGetRequest } from '../../../functions/api/general';

export const customerDetails = [
    {
        label: 'Customer number',
        value: 'PR40478954'
    },
    {
        label: ' Contact name',
        value: 'John Snow'
    },
    {
        label: 'Email',
        value: 'JohnSnow@mail.co.il'
    },
    {
        label: 'City',
        value: 'Tel Aviv Jaffa'
    },
    {
        label: 'Address',
        value: 'Rorem ipsum dolor sit amet'
    },
    {
        label: 'Year of occupancy',
        value: '06/17/2021'
    }
]
function convertKeyToName(key){
    let keyName = key.indexOf('_') > 0 ? key.split('_').join(' '): key;
    let firstChar = keyName.charAt(0).toUpperCase();
    let remainChars = keyName.slice(1);

    return firstChar + remainChars;
}

function getSelectedProperties(customer){
    const requiredProperties = [
        'customer_number',
        'name',
        'contact_name',
        'email',
        'phone',
        'city',
        'address',
        'year_of_occupancy',
        'terms_of_engagement',
    ];

    const selectedData = requiredProperties.reduce((acc, curr) => {
        acc[curr] = customer[curr];
        return acc;
    }, {});
    return selectedData;
}
function getCustomerDataInfoInToRequireFormate(customer, customerPays){
    // get selected properties of customer object to show
  const selectedProperties = getSelectedProperties(customer);

  // formatted selected properties into array of objects
  const customerDetails = [];
    for (const key in selectedProperties) {
        let keyObject;
        if (key === 'year_of_occupancy'){
            keyObject = {
                label: convertKeyToName(key),
                field: key,
                value: moment(selectedProperties[key]).format('DD/MM/YYYY')
            }
        }else{
            keyObject = {
                label: convertKeyToName(key),
                field: key,
                value: selectedProperties[key]
            }
        } 
        customerDetails.push(keyObject);
    }
    customerDetails.push({
        label: 'Customer pays',
        field: 'customer_pays',
        value: customerPays
    });
    return customerDetails;
}

export default function CustomerInfoSidebar(props) {
    const customerFromStore = useSelector((state) => state.customersPage.customerData);
    const customer = props.customer || customerFromStore || {};
    const [customerPays, setCustomerPays] = useState('');
    let customerDetails = useSelector((state) => state.customerDetails.customerDetails)

    useEffect(() => {
        let isCurrentRequest = true;
        setCustomerPays('');

        if (!customer?._id) {
            return () => {
                isCurrentRequest = false;
            };
        }

        if (customer.customer_pays !== undefined) {
            setCustomerPays(customer.customer_pays || '');
            return () => {
                isCurrentRequest = false;
            };
        }

        const loadCustomerPays = async () => {
            const ordersResponse = await getCustomerOrders(customer._id);
            const orders = ordersResponse?.ok && Array.isArray(ordersResponse.result)
                ? ordersResponse.result
                : [];
            const orderTypes = [...new Set(orders.map((order) => order.type).filter(
                (type) => type !== null && type !== undefined
            ))];
            const definitionsByType = {};

            await Promise.all(orderTypes.map(async (type) => {
                const response = await generalGetRequest(`/system/order-input/get?type=${type}`);
                if (response?.ok && Array.isArray(response.result)) {
                    definitionsByType[type] = response.result;
                }
            }));

            if (!isCurrentRequest) return;

            const value = orders.reduce((customerPaysValue, order) => {
                if (customerPaysValue) return customerPaysValue;

                const field = (definitionsByType[order.type] || []).find(
                    (input) => input.name?.trim().toLowerCase() === 'לקוח משלם'
                );
                const fieldId = field?._id || field?.id;
                const fieldValue = fieldId ? order.custom_inputs?.[fieldId] : '';
                return typeof fieldValue === 'string' || typeof fieldValue === 'number'
                    ? String(fieldValue).trim()
                    : '';
            }, '');

            setCustomerPays(value);
        };

        loadCustomerPays();

        return () => {
            isCurrentRequest = false;
        };
    }, [customer?._id, customer?.customer_pays]);

    const customerDetailsState = Object.keys(customer).length
        ? getCustomerDataInfoInToRequireFormate(
            customer,
            customer.customer_pays !== undefined ? customer.customer_pays : customerPays
        )
        : [];

    if (customerDetailsState.length) {
        customerDetails = customerDetailsState;
    }

    return (
        <Grid container spacing={0} className='sidebar__main'>
            <div className='sidebar__main__heading sidebar__main__header'><span>{TABLET_VIEW_TRANSLATION.DETAILS}</span></div>
            <div className='sidebar__main__list__container' style={{width: '100%', height: 'calc(100vh - 350px)', overflowY: 'auto'}}>
                {
                    customerDetails?.length ? customerDetails.map((customer, index) => {
                        return (<Grid className='sidebar__main__item' key={index}>
                            <div>
                                <div className='sidebar__main__heading'>
                                    <span> {customer.label}</span>
                                </div>
                                <div className='sidebar__main__text'>
                                    <span>{customer.value}</span>
                                </div>
                            </div>

                        </Grid>)
                    }) : null
                }
            </div>
           
        </Grid>
    )
}
